module.exports = __webpack_public_path__ + "img/block01.b47fa130.webp";